import axios from "axios";

export const fetchBrands = async () => {
  try {
    const endpoint = `${process.env.REACT_APP_API_URL}MasterAPI/GetAllBrands`;
    console.log("📡 Fetching:", endpoint);

    const { data } = await axios.get(endpoint);
    console.log("✅ Raw API Response:", data);

    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
      ? data.data
      : [];

    // Safe filter: handle boolean, string, number
    const activeOnly = list.filter((item) => {
      if (item.isActive !== undefined)
        return item.isActive === true || String(item.isActive).toLowerCase() === "true";
      if (item.IsActive !== undefined)
        return item.IsActive === true || String(item.IsActive).toLowerCase() === "true";
      if (item.active !== undefined)
        return item.active === true || String(item.active).toLowerCase() === "true";
      if (item.status !== undefined)
        return item.status === true || String(item.status).toLowerCase() === "true";
      return false;
    });

    return activeOnly;
  } catch (error) {
    console.error("❌ Error fetching brands:", error);
    return [];
  }
};
